import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { createDebtorSpecificationAsync, deleteDebtorSpecificationAsync, getAllDebtorSpecificationsbyDebtorIdAsync, updateDebtorSpecificationAsync } from '@application/features/debtors/debtorThunk';
import { getAllObjectsAsync } from '@application/features/workorders/workorderThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { handleRolePermission } from '@infrastructure/helpers';
import VnButton from '@ui/components/VnButton';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
import VnSelectText from '@ui/components/VnSelectText';
import VnValidation from '@ui/components/VnValidation';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
const AddInstructionForm = ({ onClose, isRepairInstructionsTabBold }) => {
    const { objectDropdown } = useAppSelector((state) => state.workorder);
    const { debtorSpecification } = useAppSelector((state) => state.debtors);
    const [opendeleteClicked, setOpendeleteClicked] = useState(false);
    const dispatch = useAppDispatch();
    const deleteClicked = () => {
        setOpendeleteClicked(true);
    };
    const onCancelDeleteClicked = () => {
        setOpendeleteClicked(false);
    };
    const { setValue, handleSubmit, register, control, watch, formState: { errors } } = useForm({
        defaultValues: {}
    });
    const keywordsValue = watch('keywords');
    const { id } = useParams();
    useEffect(() => {
        dispatch(getAllObjectsAsync());
    }, []);
    const onCreateSubmit = (data) => {
        data.debtorId = parseInt(id);
        dispatch(createDebtorSpecificationAsync(data))
            .unwrap()
            .then((res) => {
            onClose();
            if (id) {
                dispatch(getAllDebtorSpecificationsbyDebtorIdAsync(parseInt(id)))
                    .unwrap()
                    .then((res) => {
                    if (isRepairInstructionsTabBold && res.length > 0) {
                        isRepairInstructionsTabBold(true);
                    }
                    else {
                        isRepairInstructionsTabBold && isRepairInstructionsTabBold(false);
                    }
                });
            }
        });
    };
    const onUpdateSubmit = (data) => {
        data.id = debtorSpecification.id;
        dispatch(updateDebtorSpecificationAsync(data))
            .unwrap()
            .then(() => {
            onClose();
            if (id) {
                dispatch(getAllDebtorSpecificationsbyDebtorIdAsync(parseInt(id)));
            }
        });
    };
    const onDeleteClicked = () => {
        dispatch(deleteDebtorSpecificationAsync(debtorSpecification.id))
            .unwrap()
            .then(() => {
            onClose();
            setOpendeleteClicked(false);
            dispatch(getAllDebtorSpecificationsbyDebtorIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                if (isRepairInstructionsTabBold && res.length > 0) {
                    isRepairInstructionsTabBold(true);
                }
                else {
                    isRepairInstructionsTabBold && isRepairInstructionsTabBold(false);
                }
            });
        });
    };
    useEffect(() => {
        setValue('debtorId', debtorSpecification?.debtorId);
        setValue('keywords', debtorSpecification?.keywords);
        setValue('specification', debtorSpecification?.specification);
    }, [debtorSpecification]);
    return (_jsx(_Fragment, { children: _jsxs("div", { className: 'mt-4', children: [_jsxs("form", { onSubmit: debtorSpecification?.id ? handleSubmit(onUpdateSubmit) : handleSubmit(onCreateSubmit), children: [_jsx("div", { className: 'row', children: _jsxs("div", { className: 'col-sm-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Trefwoorden" }), _jsx("span", { className: 'vn-AsterikMark', children: "*" }), _jsx(Controller, { name: 'keywords', control: control, rules: { required: 'Dit veld is verplicht' }, render: ({ field: { onChange, value } }) => (_jsx(VnSelectText, { lableOptions: objectDropdown, listtype: 'trefwoordenList', value: value, onOptionChange: (selectedValue, selectedLabel) => onChange(selectedLabel), placeHolder: 'Selecteer Trefwoorden' })) }), keywordsValue ? '' : _jsx(VnValidation, { fieldError: errors.keywords })] }) }), _jsx("div", { className: 'row mt-4', children: _jsxs("div", { className: 'col-sm-12', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Voorschrift" }), _jsx("textarea", { className: 'vn-Input', rows: 8, placeholder: 'Voer voorschrift in', ...register('specification') })] }) }), _jsx("div", { className: 'vn-Form_Footer mt-4', children: _jsxs("div", { style: { display: 'flex', marginLeft: 'auto' }, children: [_jsx(VnButton, { customClassName: 'Vn-cancel-button', mode: 'secondary', onClick: onClose, type: 'button', children: "Annuleren" }), debtorSpecification?.id ? (_jsxs(_Fragment, { children: [_jsx(VnButton, { style: { marginLeft: '8px' }, customClassName: 'vn-popup-delete-button', mode: 'danger', type: 'button', onClick: () => deleteClicked(), isDisabled: !handleRolePermission(Permission.KLANTEN, PermissionType.Delete), children: "Verwijderen" }), _jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'submit', isDisabled: !handleRolePermission(Permission.KLANTEN, PermissionType.Update), children: "Opslaan" })] })) : (_jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'submit', isDisabled: !handleRolePermission(Permission.KLANTEN, PermissionType.Create), children: "Opslaan" }))] }) })] }), _jsx(VnConfirmationModel, { title: 'Wilt u dit record verwijderen?', onCancel: () => onCancelDeleteClicked(), onConfirm: () => onDeleteClicked(), onOpen: opendeleteClicked })] }) }));
};
export default AddInstructionForm;
